import PropTypes from 'prop-types'

export default function Message({ children, message }) {
  return (
    <div className="tw-bg-transparent tw-px-8 tw-py-32 tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center">
      <p className="tw-text-lg tw-text-center">{message}</p>
      {children}
    </div>
  )
}

Message.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string,
}
